<div class="company-switcher">
  <button
    #trigger
    type="button"
    class="company-switcher-trigger"
    (click)="open.set(!open())"
    [attr.aria-label]="'company.switch' | transloco"
  >
    @if (companiesService.selectedCompany(); as company) {
    <ksg-avatar
      [label]="companyInitials(company.name)"
      shape="circle"
      size="md"
    />
    @if (!collapsed()) {
    <div class="company-switcher-info">
      <span class="company-name">{{ company.name }}</span>
      @if (company.nip) {
      <span class="company-nip">NIP: {{ company.nip }}</span>
      }
    </div>
    <ksg-icon
      name="pi-chevron-up"
      class="company-switcher-chevron"
      [size]="16"
    />
    } } @else {
    <ksg-avatar icon="pi-building" shape="circle" size="md" />
    @if (!collapsed()) {
    <span class="company-name">{{ 'company.select' | transloco }}</span>
    } }
  </button>

  <ksg-popover
    [anchor]="trigger"
    [(open)]="open"
    position="top"
    [ariaLabel]="'company.switch' | transloco"
  >
    <div class="company-switcher-panel">
      @if (companiesService.companies().length > 0) {
      <p class="company-panel-label">{{ 'company.myCompanies' | transloco }}</p>
      <ul
        class="company-list"
        role="listbox"
        [attr.aria-label]="'company.myCompanies' | transloco"
      >
        @for (company of companiesService.companies(); track company.id) {
        <li
          class="company-list-item"
          [class.selected]="company.id === companiesService.selectedCompanyId()"
          role="option"
          [attr.aria-selected]="company.id === companiesService.selectedCompanyId()"
          (click)="select(company)"
          (keydown.enter)="select(company)"
          (keydown.space)="select(company)"
          tabindex="0"
        >
          <ksg-avatar
            [label]="companyInitials(company.name)"
            shape="circle"
            size="md"
          />
          <div class="company-item-info">
            <span class="company-item-name">{{ company.name }}</span>
            @if (company.nip) {
            <span class="company-item-nip">NIP: {{ company.nip }}</span>
            }
          </div>
          @if (company.id === companiesService.selectedCompanyId()) {
          <ksg-icon name="pi-check" class="company-item-check" [size]="18" />
          }
        </li>
        }
      </ul>
      } @else {
      <p class="company-panel-empty">{{ 'company.empty' | transloco }}</p>
      }
      <hr class="company-panel-sep" />
      <button type="button" class="company-logout-btn" (click)="logout()">
        <ksg-icon name="pi-sign-out" [size]="18" />
        <span>{{ 'auth.logout' | transloco }}</span>
      </button>
    </div>
  </ksg-popover>
</div>
